import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/app/layouts/admin.vue").then(m => m.default || m)),
  auth: defineAsyncComponent(() => import("/app/layouts/auth.vue").then(m => m.default || m)),
  dashboard: defineAsyncComponent(() => import("/app/layouts/dashboard.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  "patient-auth": defineAsyncComponent(() => import("/app/layouts/patient-auth.vue").then(m => m.default || m)),
  patient: defineAsyncComponent(() => import("/app/layouts/patient.vue").then(m => m.default || m)),
  support: defineAsyncComponent(() => import("/app/layouts/support.vue").then(m => m.default || m))
}